<div class="item-container">
    <div class="item-header">
      <h5 class="text-center" *ngIf="!dialogData">{{ "Add New" | translate }} {{"Package" | translate}}</h5>
      <h5 class="text-center" *ngIf="dialogData?.id">{{ "Edit"|translate}} {{"Package" | translate}}</h5>
      <div class="edit-icons" mat-dialog-close="">
        <i class="material-icons">close</i>
      </div>
    </div>  
    <div class="item-content">
      <form action="" [formGroup]="storeForm" (ngSubmit)="onSubmit()">
        <div class="col-12 mt-3">
            <label for="">{{ "Select Package" | translate }}</label>
            <div class="form-input">
              <mat-select formControlName="packageList" placeholder="Select Package" required class="form-control">
                <mat-option [value]="item.pc_i" *ngFor="let item of  packageArr"  >
                  {{item.name }}
                </mat-option>             
              </mat-select>
            </div>
            <mat-error *ngIf="isControlHasError('title', 'required')"> {{ "This is required" | translate }}</mat-error>
          </div>        
        <div class="row">
          <div class="col-md-6 m-auto mt-xl-2">
            <button  mat-raised-button  color="primary"  class="auth-form-btn no-sh-btn mt-3 mt-lg-4"  type="submit" >{{ "Save" | translate }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  
